import ApplyNowButton from "../ApplyNowButton";

const WhoCanJoinSection = () => {
  return (
    <section id="who-can-join" className="w-full flex justify-center">
      <div className="w-4/5 max-w-screen-xl py-28 flex flex-col space-y-20">
        <div>
          <h3 className="text-custom-red sm:text-7xl text-5xl font-bold">
            Kimler Katılabilir?
          </h3>
        </div>
        <div className="flex flex-col md:flex-row">
          <div
            data-aos="fade-up"
            className="flex items-center md:mr-24 justify-center mb-10"
          >
            <img
              src={require("../../assets/images/burada-hersey-yolunda1.png")}
              width="293"
              height="264"
              alt="burada hersey yolunda"
            />
          </div>
          <div className="flex flex-col space-y-7">
            <ul className="space-y-5 overflow-hidden">
              <li data-aos="fade-left" className="flex flex-row items-center">
                <code className="font-bold text-4xl text-custom-red mr-4">
                  1
                </code>
                Yeni mezun, yüksek lisans veya doktora öğrencileri,
              </li>
              <li data-aos="fade-left" className="flex flex-row items-center">
                <code className="font-bold text-4xl text-custom-red mr-4">
                  2
                </code>
                0-1 yıl iş tecrübesine sahip lisans mezunları,{" "}
              </li>
              <li data-aos="fade-left" className="flex flex-row items-center">
                <code className="font-bold text-4xl text-custom-red mr-4">
                  3
                </code>
                Sigortacılık sektöründe kariyer hedefleyenler,{" "}
              </li>
              <li data-aos="fade-left" className="flex flex-row items-center">
                <code className="font-bold text-4xl text-custom-red mr-4">
                  4
                </code>
                Analitik düşünmekten keyif alan, takım çalışmasına yatkın
                yetenekler,
              </li>
              <li data-aos="fade-left" className="flex flex-row items-center">
                <code className="font-bold text-4xl text-custom-red mr-4">
                  5
                </code>
                Öğrenmeye açık ve iletişimi güçlü gençler,
              </li>
              <li data-aos="fade-left" className="flex flex-row items-center">
                <code className="font-bold text-4xl text-custom-red mr-4">
                  6
                </code>
                2023 Şubat ayı itibarı ile veya öncesinde mezun olmuş adaylar
              </li>
            </ul>
            <ApplyNowButton />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoCanJoinSection;
